import { lazy } from 'react';
const NeedsActivity = lazy(() =>
  import('react-components/admin-dashboard/components/NeedsContent/NeedsActivity/NeedsActivity').then(
    module => ({
      default: module.NeedsActivity,
    })
  )
);
const NeedsCategories = lazy(() =>
  import('react-components/admin-dashboard/components/NeedsContent/NeedsCategories/NeedsCategories').then(
    module => ({
      default: module.NeedsCategories,
    })
  )
);
const NeedsContent = lazy(() =>
  import('react-components/admin-dashboard/components/NeedsContent/NeedsContent').then(
    module => ({
      default: module.NeedsContent,
    })
  )
);
const NeedDomains = lazy(() =>
  import('react-components/admin-dashboard/components/NeedsContent/NeedsDomains/NeedDomains').then(
    module => ({
      default: module.NeedDomains,
    })
  )
);
const NeedIssues = lazy(() =>
  import('react-components/admin-dashboard/components/NeedsContent/NeedIssues/NeedIssues').then(
    module => ({
      default: module.NeedIssues,
    })
  )
);
const NeedZcodes = lazy(() =>
  import('react-components/admin-dashboard/components/NeedsContent/NeedZcodes/NeedZcodes').then(
    module => ({
      default: module.NeedZcodes,
    })
  )
);

export const needsContentRoutes = [
  {
    path: '/admin-dashboard/needs-content',
    element: <NeedsContent />,
  },
  {
    path: '/admin-dashboard/needs-content/activities',
    element: (
      <NeedsContent>
        <NeedsActivity />
      </NeedsContent>
    ),
  },
  {
    path: '/admin-dashboard/needs-content/categories',
    element: (
      <NeedsContent>
        <NeedsCategories />
      </NeedsContent>
    ),
  },
  {
    path: '/admin-dashboard/needs-content/issues',
    element: (
      <NeedsContent>
        <NeedIssues />
      </NeedsContent>
    ),
  },
  {
    path: '/admin-dashboard/needs-content/zcodes',
    element: (
      <NeedsContent>
        <NeedZcodes />
      </NeedsContent>
    ),
  },
  {
    path: '/admin-dashboard/needs-content/domains',
    element: (
      <NeedsContent>
        <NeedDomains />
      </NeedsContent>
    ),
  },
  {
    path: '/admin-dashboard/needs-content/activities/:id/edit',
    element: (
      <NeedsContent>
        <NeedsActivity />
      </NeedsContent>
    ),
  },
  {
    path: '/admin-dashboard/needs-content/domains/:id/edit',
    element: (
      <NeedsContent>
        <NeedDomains />
      </NeedsContent>
    ),
  },
  {
    path: '/admin-dashboard/needs-content/categories/:id/edit',
    element: (
      <NeedsContent>
        <NeedsCategories />
      </NeedsContent>
    ),
  },
  {
    path: '/admin-dashboard/needs-content/issues/:id/edit',
    element: (
      <NeedsContent>
        <NeedIssues />
      </NeedsContent>
    ),
  },
  {
    path: '/admin-dashboard/needs-content/zcodes/:id/edit',
    element: (
      <NeedsContent>
        <NeedZcodes />
      </NeedsContent>
    ),
  },
];
